import { API_ENDPOINTS } from './api-config';

export interface SuggestTaskResponse {
  input_schema?: {
    type?: string;
    properties?: Record<string, any>;
  };
  output_schema?: {
    type?: string;
    properties?: Record<string, any>;
    additionalProperties?: boolean;
    required?: string[];
  };
  inputs?: any[];
  title?: string;
}

export async function suggestTask(
  intent: string,
  columns: string[]
): Promise<SuggestTaskResponse> {
  const user_intent = `${intent}\n\nChoose required inputs from this list of companies columns, must match these names exactly, do not append or prepend anything to these values: (${columns.join(
    ", "
  )})`;
  console.log("User Intent:", user_intent);
  const response = await fetch(API_ENDPOINTS.tasksSuggest, {
    headers: {
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify({
      user_intent,
    }),
  });

  if (!response.ok) {
    throw new Error(`Failed to suggest task: ${response.statusText}`);
  }

  return await response.json();
}

export interface CreateTaskResponse {
  run_id: string;
  status: string;
}

export async function createTask(
  taskSpec: any,
  input: Record<string, any>
): Promise<CreateTaskResponse> {
  const response = await fetch(API_ENDPOINTS.tasksRuns, {
    headers: {
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify({
      task_spec: taskSpec,
      input,
      processor: "base",
    }),
  });

  if (!response.ok) {
    throw new Error(`Failed to create task: ${response.statusText}`);
  }

  return await response.json();
}

export interface TaskRunStatus {
  run_id: string;
  status:
    | "pending"
    | "running"
    | "completed"
    | "failed"
    | "canceled"
    | "queued";
}

export async function getTaskRun(runId: string): Promise<TaskRunStatus> {
  const response = await fetch(API_ENDPOINTS.tasksRunsById(runId), {
    headers: {
      "Content-Type": "application/json",
    },
    method: "GET",
  });

  if (!response.ok) {
    throw new Error(`Failed to get task run: ${response.statusText}`);
  }

  return await response.json();
}

export interface TaskRunResult {
  output: {
    content: any;
    basis: any[];
  };
}

export async function getTaskRunResult(runId: string): Promise<TaskRunResult> {
  const response = await fetch(API_ENDPOINTS.tasksRunsResult(runId), {
    headers: {
      "Content-Type": "application/json",
    },
    method: "GET",
  });

  if (!response.ok) {
    throw new Error(`Failed to get task run result: ${response.statusText}`);
  }

  return await response.json();
}
